import { jsx as b, jsxs as f, Fragment as K } from "react/jsx-runtime";
import { useContext as Q, useState as R } from "react";
import { useTranslation as X } from "react-i18next";
import Y from "classnames";
import E from "../FillingItem/index.js";
import Z from "../FillGroup/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../fields/Select/index.js";
import "reactjs-popup";
import { ThemeContext as v } from "../../components/ThemeContext/index.js";
import "../../components/Button/index.js";
import "../../modal-l0sNRNKZ.js";
import "react-dropzone";
import "../../components/Breadcrumbs/index.js";
import "../../fields/Input/index.js";
import "../../components/Tooltip/index.js";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import w from "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "../../fields/Wysiwyg/index.js";
import { groupCompany as z, superFields as p, getSuperFieldsProps as N, getSuperFieldType as P, parseOrgData as nn, parseBankData as on, parsePassportData as en } from "./fillHelpers.js";
const ln = "forma-ui__fill-folder__countLabel", rn = "forma-ui__fill-folder__items", an = "forma-ui__fill-folder__switcher", $ = {
  countLabel: ln,
  items: rn,
  switcher: an
}, Nn = ({
  id: c,
  name: S,
  tattrs: r,
  register: T,
  errors: d,
  control: I,
  values: m,
  setValue: B,
  showGroupName: k,
  showCount: D,
  showSelect: s,
  onRemove: W,
  selected: t,
  onChangeSelected: g,
  itemsClassName: q
}) => {
  var j, F;
  const { t: u } = X(), { viewport: A, lang: G } = Q(v), M = r && m ? r.filter(({ id: n }) => !!m[n] && !d[n] || s && (t == null ? void 0 : t.includes(n))).length : 0, [L, C] = R({}), h = (n) => {
    Object.keys(n).forEach((o) => {
      const e = !!n[o], l = r.findIndex(({ id: i }) => o === i) !== -1;
      e && l && B(o, n[o], { shouldValidate: !0 });
    }), C((o) => ({ ...o, ...n }));
  }, U = (n, o, e) => {
    if (e) {
      if (n === "companyname") {
        const l = nn(e);
        setTimeout(() => h(l), 0);
      } else if (n === "bankname") {
        const l = on(e);
        h(l);
      } else if (n === "passport" || n === "passportcode") {
        const l = en(e);
        h(l);
      } else if (n === "address") {
        const l = p.address.filter((i) => e && !(m && m[i])).reduce((i, _) => ({ ...i, [_]: o }), {});
        h(l);
      }
    }
  }, H = (n) => {
    C((o) => {
      if (!o[n.target.id])
        return o;
      const e = { ...o };
      return delete e[n.target.id], e;
    });
  }, V = (n, o) => {
    if (!g)
      return;
    const e = t ? [...t] : [];
    n.forEach((l) => {
      if (o)
        e.includes(l) || e.push(l);
      else {
        const i = e.indexOf(l);
        if (i === -1)
          return;
        e.splice(i, 1);
      }
    }), g(e);
  }, a = z === c && r.findIndex(({ id: n }) => p.company.includes(n)) === -1 && (r.findIndex(({ id: n }) => p.inn.includes(n)) >= 0 || r.findIndex(({ id: n }) => p.ogrnip.includes(n)) >= 0) && N("companyname");
  return /* @__PURE__ */ b(
    Z,
    {
      id: c && `fill_group_content_${c}`,
      title: k && S,
      buttons: !!(s && g || k && D) && /* @__PURE__ */ f(K, { children: [
        s && g && /* @__PURE__ */ b(
          w,
          {
            containerClass: $.switcher,
            name: `checkbox_${c}`,
            label: A !== "phone" && u("uikit:select_block"),
            size: "small",
            onChange: (n) => V(r.map(({ id: o }) => o), n.target.checked),
            checked: r.every(({ id: n }) => t == null ? void 0 : t.includes(n))
          }
        ),
        k && D && (s ? /* @__PURE__ */ f("span", { children: [
          /* @__PURE__ */ f("span", { className: $.countLabel, children: [
            u("uikit:filled_or_selected"),
            ":"
          ] }),
          " ",
          M,
          "/",
          r.length
        ] }) : /* @__PURE__ */ f("span", { children: [
          /* @__PURE__ */ f("span", { className: $.countLabel, children: [
            u("uikit:filled"),
            ":"
          ] }),
          " ",
          M,
          "/",
          r.length
        ] }))
      ] }),
      percent: D && 100 * M / r.length,
      children: /* @__PURE__ */ f("div", { className: Y($.items, q), children: [
        a && /* @__PURE__ */ b(
          E,
          {
            data: {
              id: `${c}_${p.company[0]}`,
              name: u("uikit:full_company_name"),
              lang: G,
              type: a.type,
              values: a.values,
              inputText: u("uikit:full_company_name_placeholder"),
              inputWidth: 1200
            },
            form: {
              register: T,
              control: I,
              error: (j = d[`${c}_${p.company[0]}`]) == null ? void 0 : j.message,
              success: !!(m != null && m[`${c}_${p.company[0]}`] && !((F = d[`${c}_${p.company[0]}`]) != null && F.message))
            },
            onChange: (n, o) => {
              if (!o)
                return;
              const e = n.target;
              U("companyname", e.value, o);
            },
            search: {
              loadingUrl: a == null ? void 0 : a.loadingUrl,
              loadingMethod: a == null ? void 0 : a.loadingMethod,
              loadingMapper: a == null ? void 0 : a.loadingMapper
            },
            showSelect: s,
            isSuperField: !0
          }
        ),
        r && r.map((n, o) => {
          var _, O;
          const e = m && m[n.id] ? m[n.id] : "", l = P(n.id, n.type), i = l ? N(l) : null;
          return /* @__PURE__ */ b(
            E,
            {
              data: {
                ...n,
                type: (i == null ? void 0 : i.type) || n.type,
                values: (i == null ? void 0 : i.values) || n.values
              },
              form: {
                control: I,
                register: T,
                error: (_ = d[n.id]) == null ? void 0 : _.message,
                success: !!(e && !((O = d[n.id]) != null && O.message))
              },
              search: {
                loadingUrl: i == null ? void 0 : i.loadingUrl,
                loadingMethod: i == null ? void 0 : i.loadingMethod,
                loadingMapper: i == null ? void 0 : i.loadingMapper
              },
              isSuperField: !!i,
              isFilledDynamicly: !!L[n.id],
              value: e,
              onChange: (y, x) => {
                if (!x)
                  return;
                const J = y.target;
                L && H(y), l && U(l, J.value, x);
              },
              onRemove: W,
              showSelect: s,
              selected: t == null ? void 0 : t.includes(n.id),
              onSelect: (y, x) => V([y], x)
            },
            n.id + o
          );
        })
      ] })
    }
  );
};
export {
  Nn as default
};
